<template>
  <div class="table-list">
    <a-table @expandedRowsChange="expandedRowsChange" :expandedRowKeys="expandedRowKeys"
      :defaultExpandAllRows="defaultExpandAllRows" :columns="columns" :data-source="data" @change="paginchange"
      :loading="loading" :scroll="scroll" :pagination="pagination" :rowSelection="rowSelection">
      <template #headerCell="{ title, column }">
        <!-- 自定义表头 -->
        <slot :name="column.dataIndex + '_head'" :column="column" :title="title">
        </slot>
      </template>
      <template #bodyCell="{ column, record }">
        <!-- 自定义表格内容 -->
        <slot :name="column.dataIndex" :record="record">
        </slot>
      </template>
    </a-table>
    <div class="zw_more" v-if="!isPage"></div>
    <div class="more_oper" :class="{ more_bottom: !isPage }" v-if="selectedRowKeys.length && options.length">
      <a-select allowClear v-model:value="selectIs" placeholder="批量操作" style="width: 150px" :options="options"
        @change="handleChange">
      </a-select>
      <span class="select_num">已选
        <span>{{ selectedRowKeys.length }}</span>
        项数据
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    firstFlag: { //是否渲染完就请求函数
      type: Boolean,
      default: true
    },
    search_form: { // 筛选条件
      type: Object,
      default: {}
    },
    api: { //请求方法
      type: Function,
      default: () => {
        return new Promise((resolve, reject) => {
          reject()
        })
      }
    },
    columns: { // 表头
      type: Object,
      default: {}
    },
    showSizeChanger: { //是否展示 pageSize 切换器，当 total 大于 50 时默认为 true
      type: Boolean,
      default: false
    },
    showQuickJumper: { // 是否可以快速跳转至某页
      type: Boolean,
      default: true
    },
    showTotal: {
      type: Function,
      default: (total, range) => {
        return `共${total}条记录，每页${range}条`
      },
    },
    loadingFlag: { // 请求数据时是否在表格显示加载
      type: Boolean,
      default: true
    },
    scroll: {
      type: Object,
      default: {
        x: 'max-content'
      }
    },
    select: { //是否可选择
      type: Boolean,
      default: false
    },
    selectType: { // 多选或者单选 radio
      type: String,
      default: 'checkbox'
    },
    selectKey: { //指定table每行的 key
      type: String,
      default: 'id'
    },
    isPage: { // 是否分页
      type: Boolean,
      default: true
    },
    defaultExpandAllRows: { // 是否默认展开
      type: Boolean,
      default: false
    },
    options: { // 多选操作时底部的下拉框
      type: Array,
      default: []
    },
    getCheckboxProps: { // 可勾选时是否禁止选中部分
      type: Function,
      default: record => ({})
    }
  },
  data() {
    return {
      data: [],
      loading: false,
      pageInfo: {},
      selectedRowKeys: [], //所选id
      selectedRows: [], //所选数据项
      expandedRowKeys: [], //默认展开的行
      selectIs: null,
      where: {}
    }
  },
  mounted() {
    if (this.firstFlag) {
      this.getList()
    }
  },
  computed: {
    rowSelection() {
      if (!this.select) {
        return null
      }
      return {
        type: this.selectType,
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.selectChange,
        fixed: true,
        getCheckboxProps: this.getCheckboxProps
      }
    },
    pagination() {
      if (!this.isPage) {
        return false
      }
      return {
        showSizeChanger: this.showSizeChanger,
        showQuickJumper: this.showQuickJumper,
        showTotal: (total) => this.showTotal(total, this.pageInfo.pageSize),
        ...this.pageInfo
      }
    }
  },
  methods: {
    // 清空选择框
    closeSelectKeys() {
      this.selectIs = null
      this.selectedRowKeys = [] //所选id
      this.selectedRows = [] //所选数据项
      this.$emit('selectRow', {
        ids: [],
        data: []
      })
    },
    // 展开收起
    expandedRowsChange(e) {
      this.expandedRowKeys = e
    },
    // 处理级联数据
    handlerFun(arr) {
      arr.forEach(item => {
        item.key = item.id
        this.expandedRowKeys.push(item.id)
        if (item.children && item.children.length) {
          this.handlerFun(item.children)
        }
      })
    },
    getList(page = 1) {
      if (this.loadingFlag) {
        this.loading = true
      }
      this.api({
        data: {
          ...this.search_form,
          page: this.isPage ? page : null,
          ...this.where
        },
      }).then(res => {
        if (this.isPage) {
          res.list.data.forEach(item => {
            item.key = item[this.selectKey]
          })
          this.data = res.list.data
          this.pageInfo = {
            current: res.list.current_page,
            total: res.list.total,
            pageSize: res.list.per_page,
          }
        } else {
          res.list.forEach(item => {
            item.key = item[this.selectKey]
          })
          if (this.defaultExpandAllRows) {
            this.handlerFun(res.list)
          }
          this.data = res.list
        }

        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    //分页变化
    paginchange(e, filters, sort) {
      if (sort && sort.column?.sorter) {
        this.where[sort.column.sort] = sort.order == 'ascend' ? 'asc' : 'desc'
        this.getList(e.current)
      } else {
        this.where = {}
        this.getList(e.current)
      }
    },
    // 搜索
    searchList(page = 1) {
      this.$nextTick(() => {
        this.getList(page)
      })
    },
    // 当前页刷新
    pageList() {
      this.$nextTick(() => {
        this.getList(this.pageInfo.current)
      })
    },
    //表格选择
    selectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.$emit('selectRow', {
        ids: selectedRowKeys,
        data: selectedRows
      })
    },
    // 操作
    handleChange(e) {
      if (!e) {
        return false
      }
      this.$emit('handleChange', {
        value: e,
        ids: this.selectedRowKeys,
        data: this.selectedRows
      })
    }
  }
}
</script>

<style lang="less" scoped>
// :deep(.ant-table-cell) {
//     padding-left: 20px !important;
//     padding-right: 20px !important;
// }

.table-list {
  position: relative;
}

.zw_more {
  height: 50px;
}

.more_oper {
  position: absolute;
  left: 0;
  bottom: 15px;

  .select_num {
    margin-left: 20px;

    span {
      color: @color;
    }
  }
}

.more_bottom {
  bottom: 0 !important;
}
</style>